import { useEffect, useRef, useState } from "react";
import { Lock, ShieldCheck } from "lucide-react";
import axios from "axios";
import { getToken } from "@/lib/api";
import { t } from "@/lib/i18n";

const detail = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : e.message; };

export const PinGate = ({ children }) => {
  const [state, setState] = useState(null);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const base = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

  useEffect(() => {
    const check = () => axios.get(`${base}/status`, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {} })
      .then((r) => setState(!r.data.pin_required || r.data.authorized ? "ok" : "pin"))
      .catch(() => setState("pin"));
    check();
    const onRequired = () => setState("pin");
    window.addEventListener("fbwm-pin-required", onRequired);
    return () => window.removeEventListener("fbwm-pin-required", onRequired);
  }, [base]);

  useEffect(() => { if (state === "pin") setTimeout(() => ref.current?.focus(), 50); }, [state]);

  const submit = async (e) => {
    e?.preventDefault();
    if (pin.length < 6 || busy) return;
    setBusy(true); setError("");
    try {
      const r = await axios.post(`${base}/pin`, { pin });
      localStorage.setItem("fbwm_token", r.data.token);
      setState("ok");
    } catch (err) { setError(detail(err)); setPin(""); }
    finally { setBusy(false); }
  };

  if (state === null) return <div className="dark min-h-screen bg-background" />;
  if (state === "ok") return children;
  return (
    <div data-testid="pin-gate" className="dark min-h-screen bg-background text-foreground flex items-center justify-center p-6">
      <form onSubmit={submit} className="surface w-full max-w-sm p-8 space-y-6 animate-fade-up">
        <div className="flex items-center gap-3">
          <span className="h-11 w-11 rounded-md bg-primary/15 border border-primary/40 flex items-center justify-center text-primary"><Lock size={20} /></span>
          <div>
            <div className="eyebrow">F&B Wine Management</div>
            <h1 className="font-heading text-2xl font-semibold leading-tight">{t("Accesso riservato")}</h1>
          </div>
        </div>
        <p className="text-sm text-muted-foreground">{t("Inserisci il PIN a 6 cifre. Questo dispositivo resterà autorizzato.")}</p>
        <input ref={ref} data-testid="pin-input" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} onKeyDown={(e) => e.key === "Enter" && submit()}
          inputMode="numeric" autoComplete="one-time-code" placeholder="••••••" aria-label="PIN"
          className="w-full h-14 rounded-md border border-border bg-background text-center text-3xl tracking-[0.6em] num focus:outline-none focus:ring-2 focus:ring-primary" />
        {error && <div data-testid="pin-error" className="text-sm text-destructive">{error}</div>}
        <button data-testid="pin-submit" type="submit" disabled={pin.length < 6 || busy} className="w-full h-11 rounded-md bg-primary text-primary-foreground font-semibold disabled:opacity-40 flex items-center justify-center gap-2 transition-opacity">
          <ShieldCheck size={16} /> {busy ? t("Verifico…") : t("Entra")}
        </button>
      </form>
    </div>
  );
};
